import { useQuery } from "@tanstack/react-query";
import { ApiError } from "pages/admin-app/shared/models/response/api-errors";
import { ORDER_BY, PER_PAGE } from "pages/admin-app/adminapp.constants";
import { GetTerritoryManagersResponse } from "../models/response/get-territory-managers-response";
import { getTerritoryManagers } from "../services/territory-manager-service";

interface Props {
  currentPage: number;
  sortBy?: string;
  orderBy?: ORDER_BY;
  filters?: { [key: string]: string };
  searchQuery?: string;
}

export function useTerritoryManagers({
  currentPage,
  sortBy,
  orderBy,
  filters,
  searchQuery,
}: Props) {
  const { data, error, isLoading, isError, refetch, isFetching } = useQuery<
    GetTerritoryManagersResponse,
    ApiError
  >({
    queryKey: [
      "territoryManagers",
      currentPage,
      sortBy,
      orderBy,
      filters,
      searchQuery,
    ],
    queryFn: () =>
      getTerritoryManagers({
        page: currentPage,
        perPage: PER_PAGE,
        sortBy,
        orderBy,
        filters,
        searchQuery,
      }),
  });

  const baseErrorResponse = error ? error.message : null;

  return {
    data: data,
    error: baseErrorResponse,
    isLoading,
    isError,
    refetch,
    isFetching,
  };
}
